(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hawaii-shirts"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.hawaii_btn');
  
  buttons.forEach(button => {
    const btnBg = button.style.backgroundColor;
    const btnColor = button.style.color;
    const btnHoverBg = button.getAttribute('data-hover-bg') || '#C43838';
    const btnHoverColor = button.getAttribute('data-hover-color') || '#ffffff';
    
    button.addEventListener('mouseenter', function() {
      const hoverBg = this.closest('.prd_wrp').querySelector('.hawaii_btn').getAttribute('data-hover-bg');
      const hoverColor = this.closest('.prd_wrp').querySelector('.hawaii_btn').getAttribute('data-hover-color');
      if (hoverBg) this.style.backgroundColor = hoverBg;
      if (hoverColor) this.style.color = hoverColor;
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.backgroundColor = btnBg;
      this.style.color = btnColor;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qoutes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.reviews-track');
  const cards = document.querySelectorAll('.review-card');
  const prevBtn = document.querySelector('.slider-nav-prev');
  const nextBtn = document.querySelector('.slider-nav-next');
  const dots = document.querySelectorAll('.dot');
  
  if (!track || cards.length === 0) return;

  // Fix "collapsed" names like "EmmaThompson" -> "Emma Thompson"
  // Also handles "MichaelDavis", etc. Leaves already-spaced names alone.
  document.querySelectorAll('.reviewer-name').forEach((el) => {
    const raw = (el.textContent || '').trim();
    if (!raw) return;
    const spaced = raw.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\s{2,}/g, ' ');
    if (spaced !== raw) el.textContent = spaced;
  });
  
  let currentIndex = 0;
  let cardsPerView = 4;
  let isMobileGrid = false;
  
  function updateCardsPerView() {
    if (window.innerWidth <= 600) {
      cardsPerView = 1;
      isMobileGrid = true;
    } else if (window.innerWidth <= 900) {
      cardsPerView = 2;
      isMobileGrid = false;
    } else if (window.innerWidth <= 1200) {
      cardsPerView = 3;
      isMobileGrid = false;
    } else {
      cardsPerView = 4;
      isMobileGrid = false;
    }
  }
  
  function updateSlider() {
    if (isMobileGrid) {
      currentIndex = 0;
      track.style.transform = 'none';
      return;
    }
    const cardWidth = cards[0].offsetWidth;
    const gap = 20;
    const offset = currentIndex * (cardWidth + gap);
    track.style.transform = `translateX(-${offset}px)`;
    
    // Update dots
    dots.forEach((dot, index) => {
      if (index === currentIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
  
  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      const maxIndex = cards.length - cardsPerView;
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    });
  }
  
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
  }
  
  dots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      currentIndex = index;
      updateSlider();
    });
  });
  
  window.addEventListener('resize', function() {
    updateCardsPerView();
    updateSlider();
  });
  
  updateCardsPerView();
  updateSlider();
});

  } catch(e) { console.error(e); }
})();
})();
